export default "__VITE_ASSET__ee33b7bb__"